import { checkOfferIncludesDynamicPricingProduct } from '../../../shared/helpers';
import { CostDetails, Offer , OfferType } from '../../../shared/types';

export const formatDateToDutch = (isoDate: string): string => {
  const date = new Date(isoDate);
  return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${date.getFullYear()}`;
};

export const getDisplayYear = (
  offer: Offer | undefined,
  discountType: string | undefined,
  useNextYear = false,
): string => {
  if (checkOfferIncludesDynamicPricingProduct(offer) && !discountType?.includes(OfferType.Variable)) return '';

  const currentYear = new Date().getFullYear();
  return useNextYear ? String(currentYear + 1) : String(currentYear);
};

export const getTotalUsageFromTaxBrackets = (
  taxDetails: Record<string, { active?: boolean; usage?: number }> | undefined,
): number =>
  Object.values(taxDetails ?? {}).reduce((sum, bracket) => sum + (bracket.active ? (bracket.usage ?? 0) : 0), 0);

interface RedeliveryTariffPopoverParams {
  costDetails?: CostDetails;
  solarPanelsOutput?: number | null;
  popoverDescription?: string;
  usage?: number;
  nettedUsage?: number;
  futureUsage?: number;
  formatElectricity: (value: number) => string;
}

export const getRedeliveryTariffPopoverDescription = ({
  costDetails,
  solarPanelsOutput = 0,
  popoverDescription,
  usage = 0,
  nettedUsage = 0,
  futureUsage = 0,
  formatElectricity,
}: RedeliveryTariffPopoverParams): string => {
  const totalRedeliveryRefund = costDetails?.electricityTotal?.electricityRedeliveryRefund?.netUsage ?? 0;
  const totalRedelivery =
    (solarPanelsOutput ?? 0) -
    (costDetails?.electricityFutureCostDetails?.electricityRedeliveryRefund?.usage ?? 0);
  const futureRedeliveryRefund = costDetails?.electricityFutureCostDetails?.electricityRedeliveryRefund?.usage ?? 0;
  const futureRedeliveryCost = costDetails?.electricityFutureCostDetails?.redeliveryCost?.usage ?? 0;

  if (!popoverDescription) return '';

  return popoverDescription
    .replaceAll('{totalUsage}', formatElectricity(usage))
    .replaceAll('{nettedUsage}', formatElectricity(nettedUsage))
    .replaceAll('{totalRedeliveryRefund}', formatElectricity(totalRedeliveryRefund))
    .replaceAll('{totalRedelivery}', formatElectricity(totalRedelivery))
    .replaceAll('{futureUsage}', formatElectricity(futureUsage))
    .replaceAll('{futureRedeliveryRefund}', formatElectricity(futureRedeliveryRefund))
    .replaceAll('{futureRedeliveryCost}', formatElectricity(futureRedeliveryCost));
};
